export default __webpack_public_path__ + "static/media/Aura-Egg__91.44b74c49.png";